import { ApiReturn, HttpClient } from "tsrpc-browser";
import { serviceProto, ServiceType } from "./shared/protocols/serviceProto";
import { config } from "./config";

let client: HttpClient<ServiceType> | null = null

export async function initClient() {
    if (client) return
    client = new HttpClient(serviceProto, { server: config.api_url })
    client.flows.preCallApiFlow.push(v => {
        console.log('[PRE CALL API]', v.apiName, v.req)
        return v
    })
    client.flows.postApiReturnFlow.push(v => {
        console.log('[POST API RETURN]', v.apiName, v.req, v.return)
        return v
    })
    client.flows.postApiReturnFlow.push(v => {
        if (v.return.err?.message === '201040' || v.return.err?.message === '201041') window.location.href = "/login"
        return v
    })
}

export async function call<T extends string & keyof ServiceType['api']>(apiName: T, req: ServiceType['api'][T]['req'], options?: any): Promise<ApiReturn<ServiceType['api'][T]['res']>> {
    while (!client) await new Promise(r => setTimeout(r, 100))
    return await client!.callApi(apiName, req, options)
}

export function dataCall<T extends string & keyof ServiceType['api'] & `editor/Data${string}`>(apiName: T, req: Omit<ServiceType['api'][T]['req'], 'timestamp' | 'token'>, options?: any) {
    return call(apiName, { timestamp: Date.now(), token: localStorage.getItem("token") || "", ...req }, options)
}

export async function uploadCall(path: string, data: File): Promise<{ isSucc: true, res: { md5: string } } | { isSucc: false, err: Error }> {
    const form = new FormData()
    form.append('file', data)
    form.append('path', path)
    const token = localStorage.getItem("token") || ""
    try {
        const url = new URL(window.location.href)
        url.port = config.upload_port
        url.pathname = '/upload'
        const res = await fetch(url.toString(), {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` },
            body: form,
            credentials: 'include'
        })
        return { isSucc: true, res: await res.json() }
    } catch (e: any) {
        return { isSucc: false, err: e.message }
    }
}

export async function downloadCall(dir: string): Promise<{ isSucc: true } | { isSucc: false, err: Error }> {
    try {
        const url = new URL(window.location.href)
        url.port = config.upload_port
        url.pathname = '/download'
        url.search = `?dir=${dir}`
        const res = await fetch(url.toString(), {
            method: 'GET',
            headers: { 'Authorization': `Bearer ${localStorage.getItem("token") || ""}` },
            credentials: 'include'
        })
        const blob = await res.blob()
        const urlCreator = window.URL || window.webkitURL
        const link = document.createElement('a')
        link.href = urlCreator.createObjectURL(blob)
        link.download = dir.split('/').pop()!
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return { isSucc: true }
    } catch (e: any) {
        return { isSucc: false, err: e.message }
    }
}

export function deleteCall(path: string, options?: any) {
    return call('editor/FileDelete', { timestamp: Date.now(), token: localStorage.getItem("token") || "", path }, options)
}